module.exports = __webpack_public_path__ + "media/images/career_camp/2022/home_unicorn-3e3eb7aecaaeaa4b78d86d1f0243e623.svg";